import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import Modal from '@/components/modalBase/modalBase'
import { Getter, Action, Mutation } from 'vuex-class'

@Component({
  components: { Modal }
})
export default class ModalPromoExceeded extends Vue {
  @Prop({ default: false }) show;

  @Getter getLastPromoExceededProduct: any
  @Getter getCountry: any

  @Mutation LAST_PROMO_EXCEEDED_PRODUCT
  @Mutation OPEN_PROMO_EXCEEDED_MODAL

  mounted() {

  }

  get maxPromoQuantity() {
    let response = 0;
    const lastProd = this.getLastPromoExceededProduct;
    if(lastProd && lastProd.promo && lastProd.promo.max_promos_per_cart) {
      response = lastProd.promo.max_promos_per_cart
    }
    return response;
  }

  get basePrice() {
    let response = 0;
    const lastProd = this.getLastPromoExceededProduct;
    if(lastProd && lastProd.base_price) {
      response = lastProd.base_price;
    }
    return this.localCurrencyFormat(response);
  }

  get productName() {
    let response = "";
    if(this.getLastPromoExceededProduct && this.getLastPromoExceededProduct.name) {
      response = this.getLastPromoExceededProduct.name;
    }
    return response;
  }

  private localCurrencyFormat(value) {
    if(this.getCountry && this.getCountry.currency) {
      return this.$currency.format(value, { code: this.getCountry.currency });
    }
    return value;
  }

  _onCloseModal() {
    this.OPEN_PROMO_EXCEEDED_MODAL(false);
    this.LAST_PROMO_EXCEEDED_PRODUCT(null);
  }

}